import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonPage, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, flag } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { operacaoProjetoCarregar, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./OrdensOperacoes.css";

type Props = {
  projetoid: string;
  configs: Object;
  abrirInserirOperacao: boolean;
  onDismiss: () => void;
};

const OrdensOperacoes: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [listaOperacoes, setListaOperacoes] = useState<any>([]);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {

    setEsconderMenu(true);

  });


  let params: any = {
    projetoid: "",
    abrirInserirOperacao: false,
    configs: "",
  }
  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
    params.configs = location.state.configs;
    params.abrirInserirOperacao = location.state.abrirInserirOperacao;
  }


  if (props.projetoid) {
    params = {
      projetoid: props.projetoid,
      configs: props.configs,
      abrirInserirOperacao: props.abrirInserirOperacao
    }
  }


  function carregarOperacoes() {

    if (params.projetoid != "" && params.projetoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);
        consultarOperacoes(params.projetoid);
      }
    }
    return "";
  }


  function consultarOperacoes(projetoid: any) {
    const consultarOperacaoPorProjeto = async () => {


      setShowLoading(true);

      requestService(operacaoProjetoCarregar.url.replaceAll("{projetoid}", projetoid.replaceAll(/#/g, "%23")), {
        method: operacaoProjetoCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response.Items", response.Items);
          setListaOperacoes(response.Items);
        },
        (error: any) => {
          if (error.status === 426) { // atualizar versao
            history.replace("/atualizar");
          }
          else if (error.status !== 408) {
            history.replace("/primeiroacesso/");
          }
        }).finally(() => {
          setShowLoading(false);
        });
    }

    consultarOperacaoPorProjeto();

  }



  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  function formatarDataHora(data: Date) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + ("0" + data.getHours().toString()).substr(-2) + ":" + ("0" + data.getMinutes().toString()).substr(-2);
  }

  function formatarDataPeriodo(data: Date, periodo: string) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + periodo;
  }

  const loadOperacoes = () => {

    if (listaOperacoes == undefined) return;

    if (listaOperacoes.length === 0) {
      return (
        <IonItem lines="full" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Aguarde as operações serem abertas</strong></h2>
          </IonLabel>

        </IonItem>
      );
    }

    return listaOperacoes.map((value: any, index: any) => (
      <IonItem lines="full" detail onClick={(e: any) => {

        history.push("../operacoes/acompanhar", { estabelecimento: "A", codigoBarras: "B", operacaoid: value.pk.replace(/#/g, '%23') });

      }} key={index}>

        <IonIcon icon={flag} slot="start"> </IonIcon>
        <IonLabel>
          <h2 style={{ "verticalAlign": "middle" }}><strong>{formatarDataHora(new Date(value.dataInicio)) + " - " + value.status}  </strong></h2>
          <h3>{value.descricaoAgendamento + ' - ' + value.tipoOperacao + ' - ' + value.motoristaNome}</h3>
        </IonLabel>

      </IonItem>
    ));
  }


  return (

    <IonPage className="OrdensOperacoes">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <div>
            {carregarOperacoes()}
          </div>
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Operacões</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>


        {loadOperacoes()}

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );

};

export default OrdensOperacoes;